module.exports = __webpack_public_path__ + "212c84116c13b8190b0cb15dacf17ad3.svg";